import React, {useState} from "react";
import {Tooltip} from "reactstrap";
import './iconLiTooltip.scss'
import AppLink from "../AppLink";

export function IconLiTooltip({link, id, icon, tooltipMessage, style, className, target}) {
  const [tooltip, setTooltip] = useState(false);
  const DirectionToggle = () => setTooltip(!tooltip);

  function iconContent() {
    return (
      <>
        <i
          onClick={() => {
          }}
          className={icon}
        ></i>
        <Tooltip
          placement={'bottom'}
          isOpen={tooltip}
          target={target}
          toggle={DirectionToggle}
        >
          {tooltipMessage}
        </Tooltip>
      </>
    )
  }

  return link ?
    <AppLink to={`${link}`}>
      {iconContent()}
    </AppLink> :
    <a style={{cursor:'pointer'}} onClick={e=>e.preventDefault()}>{iconContent()}</a>


}
